import { render } from "./DetailsSection.vue?vue&type=template&id=59b8b2f7&scoped=true"
import script from "./DetailsSection.js?vue&type=script&lang=js"
export * from "./DetailsSection.js?vue&type=script&lang=js"

import "./DetailsSection.scss?vue&type=style&index=0&id=59b8b2f7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b8b2f7"]])

export default __exports__